import {inject} from "@angular/core";
import {PrimeNGConfig} from "primeng/api";

export function initializePrimeNgConfig() {
  const primengConfig = inject(PrimeNGConfig);

  return () => {
    primengConfig.setTranslation({
      firstDayOfWeek: 1,
    });
  };
}
